import api from 'base/utils/api';
import { ICodeListItem, IFinishTaskApi, IFinishTaskData, IReferralConfig, IRewardItem } from 'mod/referral/interface';

// 获取 Referral 配置
export const fetchReferralConfig = (): Promise<IReferralConfig> => {
    return api.get('/web/referral/config')
};

// 获取推广奖励列表
export const fetchRewardsPage = (page: number = 1): Promise<Globals.Pagination<IRewardItem>> => {
    return api.post('/web/referral/rewards/list', {
        data: {
            page,
            pageSize: 10,
        }
    })
};

// 获取用户referral code列表
export const fetchCodeList = (codes: string[]): Promise<ICodeListItem[]> => {
    return api.post('/web/referral/code/list', {
        data: { codes }
    }).then(res => res.list)
};

// 完成任务
export const finishTask = (params: IFinishTaskApi): Promise<IFinishTaskData> => {
    return api.post('/web/referral/task/finish', {
        data: params
    })
};
